import { BehaviorSubject } from 'rxjs';
import { Operation } from '../base/operation';

export class AttachOperation extends Operation {
  constructor(operations: BehaviorSubject<AttachOperation[]>) {
    super(operations);
    this.deleteTimeoutAfterComplete = 3000;
    this.deleteTimeoutAfterFail = 10000;
    this.minDelayFromProcessingToComplete = 0;
    this.failAfterIdleTimeout = 1200000;
  }
}
